// extracted by mini-css-extract-plugin
export default {"header":"rU-z"};